import React from 'react';
import {KTMScreen,ActionEvent,RenderEvent,renderScreen, Panel, Column, Card, Line} from 'ktm-ui';
import {KTMApi} from 'api/KTMApi';
import {Button,DataGrid,IDataGridLayout} from 'ktm-ui';
import Add_date_rangeScreen from './Add_date_range';
import Edit_date_rangeScreen from './Edit_date_range';
import Remove_date_rangeScreen from "./Remove_date_range";
import { FaMinusCircle } from "react-icons/fa";
import ReactMoment from "react-moment";
import CustomToolTip from "../../components/CustomToolTip";
import InfoBox from 'components/InfoBox';
import "../../styles/Employee.css";
import "../../styles/CustomComponents.css";

interface IdsData {
    Id:string;
    Policy_Id:string;
    Employee_Id:string;
    Dependent_Id:string;
    RangeType:string;
    FromDate:string;
    ToDate:string;
    Comment:string;
    DependentName:string;
    RangeTypeLabel:string;
    IncludePartialAccrualCycle:boolean;
};

export default KTMScreen(
  {name:"enroll.employee.date-range-list" },
  class extends React.Component<{ employee_id: string }> {

    data:{
        dsData:IdsData[];
    }

    state = {
      dateRangeLog: [],
      isHistoryVisible: true,
      hasAccrual: false,
    }

    render(){
        return renderScreen(this);
    }

    componentDidMount() {
      this.getLogs();
    }

    async start({screen}:ActionEvent){
        screen.defaultRecord = "@dsData";
        await KTMApi.start(screen,{
            "@employee_id":this.props.employee_id,
        });

        try {
          const response = await fetch(`/api/Employees/checkemployeehasaccrual?employeeId=${this.props.employee_id}`);
          const result = await response.json();
          this.setState({ hasAccrual: result.hasAccrual });
        } catch (err) {
          console.error("Failed to load HasAccrual status:", err);
        }
        await this.setEmployee();
        screen.title = "Date ranges";
    }

    main({ field, draw, action }: RenderEvent) {
      const showList = this.data.dsData && this.data.dsData.length > 0;
      const showHistoryLogs = this.state.dateRangeLog && this.state.dateRangeLog.length > 0;

      return (
        <Panel>
          {showList ? (
            <Column>
              {draw(this.default_view)}
              {this.state.hasAccrual && draw(this.date_range_text)}
              {showHistoryLogs && draw(this.history_logs)}
            </Column>
          ) : (
            <Column>
              {draw(this.note)}
              {showHistoryLogs && draw(this.history_logs)}
            </Column>
          )}
        </Panel>
      );
    }

    default_view({field,draw,action,collection}:RenderEvent){
        let actions = (<><Button action={action(this.add)} label="Add Date Range" style="add"/> </>);
        let layout:IDataGridLayout = {
            columns:[
                {name:"RangeTypeLabel",label:"Range Type",type:"character"},
                {name:"DependentName",label:"Person",type:"character",width:200},
                {name:"FromDate",label:"From Date",type:"date"},
                {name:"ToDate",label:"To Date",type:"date"},
                {name:"Comment",label:"Comment",type:"longchar",width:200},
                {action:"edit",label:"Edit",width:80},
                {action:"remove",label:"Remove",width:80},
                {
                  name: "Note",
                  label: "Note",
                  width: 80,
                  render: (row) => {
                    const note = row.Note;
                    return note ? (
                    <CustomToolTip
                      header="Note"
                      bodyContent={note}
                    >
                      <div style={{ cursor: "pointer", color: "#007bff", textDecoration: "underline" }}>
                        View
                      </div>
                    </CustomToolTip>
                      ) : null;
                    }
                  }
            ],
            sort:[{name:"FromDate",descending:true},{name:"DependentName"}]
        };
        return (
            <DataGrid collection={collection("@dsData")} layout={layout} actions={actions}/>
        );
    }

    note({ field, draw, action, collection }: RenderEvent) {
      const actions = (
        <div className="dr-buttonRow">
          <Button action={action(this.add)} label="Add Date Range" style="add" />
        </div>
      );

      return (
        <div className="dr-container">
          <div className="dr-iconWrap">
            <FaMinusCircle color="#bebebe" size={64} />
          </div>

          <div className="dr-title">Welcome to date ranges!</div>

          <div className="dr-description">
            If you need to enter a date range for this employee or their dependents, this is the place to do it!
            You can enter a date range for a parental leave or leave of absence and more. This is also the place to
            apply Student Status to dependents, ensuring they are eligible under the Student Status extended upper age limit.
          </div>

          {this.state.hasAccrual && draw(this.date_range_text)}

          {actions}
        </div>
      );
    }

    toggleHistory = () => {
      this.setState({ isHistoryVisible: !this.state.isHistoryVisible });
    };

    history_logs({ field, draw, action }: RenderEvent) {
      let historyLogTable = null;
      historyLogTable = (
        <div className="history-content">
        <table className="table table-hover ktm-table" style={{ width: "100%", tableLayout: "fixed" }}>
            <thead>
              <tr>
                <th style={{ width: "300px" }}>Action</th>
                <th>Details</th>
                <th style={{ width: "200px" }}>Timestamp</th>
                <th style={{ width: "200px" }}>Modified By</th>
              </tr>
            </thead>
            <tbody>
              {this.state.dateRangeLog.map((data, i) => {
                const updatedAt = (
                  <ReactMoment format="YYYY-MM-DD HH:mm:ss">
                    {data.updatedAt}
                  </ReactMoment>
                );
                return (
                  <tr key={i}>
                    <td>{data.action}</td>
                    <td>
                      <div
                        dangerouslySetInnerHTML={{ __html: data.note }}
                      />
                    </td>
                    <td>{updatedAt}</td>
                    <td>{data.author}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      );

      return (
        <div style={{ marginTop: 15 }}>
          <Card
            label="History Logs"
            actions={
              <button
                onClick={this.toggleHistory}
                className={`toggle-button ${
                  this.state.isHistoryVisible ? "open" : ""
                }`}
              >
                <span className="arrow"></span>
              </button>
            }
          >
            {this.state.isHistoryVisible && this.state.dateRangeLog && (
              <Line>{historyLogTable}</Line>
            )}
          </Card>
        </div>
      );
    }

    date_range_text({ field, draw, action }: RenderEvent) {
      return (
        <InfoBox style={{ color: "rgb(21, 137, 238)"}} className="date-range-text">
          <p style={{ marginTop: 0 }}>
            Applying an Inactive Date Range to the employee with Scheduled Credits will make the employee:
          </p>
          <ul
            style={{
              marginTop: 6,
              marginBottom: 6,
              marginLeft: "1.25rem",
              paddingLeft: "1rem",
              listStyle: "disc",
              color: "rgb(21, 137, 238)",
            }}
          >
            <li>unable to claim expenses dated within and including the dates entered.</li>
            <li>ineligible for Scheduled Credit increment amounts where they are fully inactive.</li>
          </ul>
          <p style={{ marginBottom: 0 }}>
            The employee’s yearly benefit total will reflect the update immediately. Start and end dates are inclusive.
          </p>
        </InfoBox>
      );
    }

    getLogs = async () => {
      await fetch("/api/PlanAdmin/getdaterangelogs?id=" + this.props.employee_id, {
        method: "GET",
      })
        .then((response) => response.json())
        .then((data) => {
          this.setState({
            dateRangeLog: data,
          });
        })
        .catch((error) => {
          console.error(error);
        });
    };

    async search({screen}:ActionEvent){
        await KTMApi.action(screen,"search",{
            "@employee_id":this.props.employee_id,
        });
    }

    async add({screen}:ActionEvent){
        await screen.openDialog(<Add_date_rangeScreen employee_id={this.props.employee_id}/>
,{onRecordChanged:this.refresh_row});
        await this.getLogs();
    }

    async edit({screen}:ActionEvent){
        await screen.openDialog(<Edit_date_rangeScreen dateRange_id={screen.getValue("Id")}/>
,{onRecordChanged:this.refresh_row});
        await this.getLogs();
    }

  async remove({screen}:ActionEvent){
    await screen.openDialog(<Remove_date_rangeScreen dateRange_id={screen.getValue("Id")} employee_id={this.props.employee_id} type={screen.getValue("RangeTypeLabel")} FromDate={screen.getValue("FromDate")} ToDate={screen.getValue("ToDate")} DependentName={screen.getValue("DependentName")} />
,{onRecordChanged:this.refresh_data});
    await this.getLogs();
}

    async refresh_row({screen,eventValue}:ActionEvent){
        await KTMApi.refreshRow(screen,{collection:
"@dsData",rowid:eventValue});
        await this.setEmployee();
    }

  async refresh_data({screen}:ActionEvent){
     await screen.restart();
  }

  async setEmployee(){
    if (this.data.dsData && this.data.dsData.length > 0) {
      for (let i = 0; i < this.data.dsData.length; i++) {
        let row = this.data.dsData[i];
        if (row.Dependent_Id == null && row.DependentName == "") {
          row.DependentName = "Employee";
        }

        if(this.state.hasAccrual){
          let today = new Date();
          today.setHours(0, 0, 0, 0);
          // Backdated inactive date range condition
          const isInactive = row.RangeType?.toLowerCase() === "inactive";
          const isEmployee = row.DependentName == "Employee";
          const fromDate = new Date(row.FromDate);
          const isBackdated = fromDate < today;
          if (isInactive && isEmployee && isBackdated) {
            const dateOfEntry = new Date().toISOString().split("T")[0]; // fallback
            row["Note"] = `Backdated inactive date range was applied ${dateOfEntry}: expenses dated within the date range are ineligible to claim, but Scheduled Credit amounts already earned prior to this date of entry remain Earned.`;
          }
        }
      }
    }
  }

});
